import { ListOption } from '../modules/tcm-core.module';

export class ListOptionHelper {
  public static fromTranslation(translation: any): ListOption<number>[] {

    const result = [] as ListOption<number>[];

    if (translation) {
      Object.keys(translation).map(key =>
        result.push({
          value: +key,
          displayName: translation[key]
        } as ListOption<number>));
    }

    return result;
  }

  public static fromRawValues<TValue>(items: TValue[]): ListOption<TValue>[] {

    const result: ListOption<TValue>[] = [];

    if (items) {
      for (let item of items) {
        result.push({
          value: item,
          displayName: item.toString()
        });
      }
    }

    return result;
  }
}
